import React, { useEffect, useState } from "react";
import "../assets/css/custom.css";
import "../assets/css/client.css";
import "../assets/css/management.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPenToSquare,
  faTrash,
  faCheck,
  faTimes,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Table from "react-bootstrap/Table";
import { toast } from "react-toastify";
import { commonAPI } from "../services/CommonAPIService";

const BLUE_COLOR = "#00afef";

const Escalation = () => {
  const [escalationData, setEscalationData] = useState([]);
  const [escalationLoading, setEscalationLoading] = useState(false);
  const [editingEscalationRow, setEditingEscalationRow] = useState(null);
  const [refreshEscalation, setRefreshEscalation] = useState(0);
  const [showAddRow, setShowAddRow] = useState(false);
  const [showFAB, setShowFAB] = useState(true);
  const [pendingRecipientSave, setPendingRecipientSave] = useState(false);

  const [categoryList, setCategoryList] = useState([]);
  const [categoryWithSubCategories, setCategoryWithSubCategories] = useState([]);

  const [editSelections, setEditSelections] = useState({});
  const [editLevel1Hour, setEditLevel1Hour] = useState({});
  const [editLevel2Hour, setEditLevel2Hour] = useState({});
  const [editLevel3Hour, setEditLevel3Hour] = useState({});

  const [recipient1Input, setRecipient1Input] = useState("");
  const [recipient2Input, setRecipient2Input] = useState("");
  const [recipient3Input, setRecipient3Input] = useState("");
  const [recipient1List, setRecipient1List] = useState([]);
  const [recipient2List, setRecipient2List] = useState([]);
  const [recipient3List, setRecipient3List] = useState([]);
  const [recipientIdMap, setRecipientIdMap] = useState({});

  const [newEscalationData, setNewEscalationData] = useState({
    categoryId: "",
    subCategoryId: "",
    escalationHour1: "",
    escalationHour2: "",
    escalationHour3: "",
  });

  const [DeleteShow, setDeleteShow] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);

  // --------------------------------------------------------------- //
  // --------------------------- HELPERS --------------------------- //
  // --------------------------------------------------------------- //
  
  const getLoggedUserId = () => {
    const auth = localStorage.getItem("userData");
    return auth ? JSON.parse(auth).userId : "";
  };

  const getBuildingId = () => {
    const auth = localStorage.getItem("userData");
    return auth ? JSON.parse(auth).buildingId : null;
  };

  const getSubCategoriesForCategory = (categoryId) => {
    const cat = categoryWithSubCategories.find(
      (c) => c.categoryId === parseInt(categoryId)
    );
    return cat ? cat.subCategory || [] : [];
  };

  const saveLevelRecipients = async (level, emails, showToast = false) => {
    const uid = getLoggedUserId();
    if (!uid) {
      toast.error("User not logged in");
      return false;
    }

    const payload = {
      escalationLevel: level,
      recipientList: emails.join("; "),
    };

    if (recipientIdMap[level]) {
      payload.recipientId = recipientIdMap[level];
    }

    const endPoint = { urlVariable: null, buildingId: getBuildingId() };

    try {
      const res = await commonAPI("AddComplaintEscalationRecipient", payload, endPoint);
      if (res?.success) {
        setRefreshEscalation((p) => p + 1);
        return true;
      } else {
        if (showToast) toast.error(res?.message?.[0] || `Level ${level} save failed`);
        return false;
      }
    } catch (err) {
      if (showToast) toast.error("Error saving recipients");
      return false;
    }
  };

  const addRecipient = async (level) => {
    let input = "", setInput, list = [], setList;

    if (level === 1) {
      input = recipient1Input; setInput = setRecipient1Input; list = recipient1List; setList = setRecipient1List;
    } else if (level === 2) {
      input = recipient2Input; setInput = setRecipient2Input; list = recipient2List; setList = setRecipient2List;
    } else {
      input = recipient3Input; setInput = setRecipient3Input; list = recipient3List; setList = setRecipient3List;
    }

    const email = input.trim();
    if (!email) return;
    if (!/^[\w.-]+@[\w.-]+\.\w+$/.test(email)) {
      return toast.warning("Please enter a valid email");
    }

    const newList = [...list, email];
    setList(newList);
    setInput("");
    await saveLevelRecipients(level, newList);
  };

  const removeRecipient = async (level, index) => {
    
    let list = [], setList;
    if (level === 1) { list = recipient1List; setList = setRecipient1List; }
    else if (level === 2) { list = recipient2List; setList = setRecipient2List; }
    else { list = recipient3List; setList = setRecipient3List; }

    const newList = list.filter((_, i) => i !== index);
    setList(newList);
    await saveLevelRecipients(level, newList);
  };

  const handleFABClick = async () => {
    if (pendingRecipientSave) return;
    setPendingRecipientSave(true);

    const promises = [];
    if (recipient1List.length) promises.push(saveLevelRecipients(1, recipient1List, true));
    if (recipient2List.length) promises.push(saveLevelRecipients(2, recipient2List, true));
    if (recipient3List.length) promises.push(saveLevelRecipients(3, recipient3List, true));

    const results = promises.length ? await Promise.all(promises) : [true];
    const allSuccess = results.every((r) => r);

    setRefreshEscalation((p) => p + 1);
    setPendingRecipientSave(false);

    if (allSuccess) {
      setShowAddRow(true);
      setShowFAB(false);
    } else {
      toast.error("Failed to save recipients");
    }
  };

  const cancelAddRow = () => {
    setShowAddRow(false);
    setNewEscalationData({
      categoryId: "",
      subCategoryId: "",
      escalationHour1: "",
      escalationHour2: "",
      escalationHour3: "",
    });
    setShowFAB(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setEscalationLoading(true);
        const endPoint = { urlVariable: null, buildingId: getBuildingId() };

        const [escRes, catRes] = await Promise.all([
          commonAPI("GetComplaintEsclation", null, endPoint),
          commonAPI("GetComplaintCategory", null, endPoint),
        ]);

        if (escRes?.success) {
          const escalations = escRes.data?.complaintEscalations || [];
          const recipients = escRes.data?.complaintEscalationRecipients || [];

          setEscalationData(escalations);

          setEditSelections({});
          setEditLevel1Hour({});
          setEditLevel2Hour({});
          setEditLevel3Hour({});

          const rMap = { 1: [], 2: [], 3: [] };
          const idMap = {};

          recipients.forEach((r) => {
            if (r.escalationLevel >= 1 && r.escalationLevel <= 3 && r.recipientList) {
              const emails = r.recipientList
                .split(/[:;]/)
                .map((e) => e.trim())
                .filter(Boolean);
              rMap[r.escalationLevel].push(...emails);
              idMap[r.escalationLevel] = r.recipientId;
            }
          });

          setRecipient1List(rMap[1]);
          setRecipient2List(rMap[2]);
          setRecipient3List(rMap[3]);
          setRecipientIdMap(idMap);
        }

        if (catRes?.success) {
          const data = catRes.data || [];
          setCategoryWithSubCategories(data);
          setCategoryList(data);
        }
      } catch (err) {
        toast.error("Failed to load data");
      } finally {
        setEscalationLoading(false);
      }
    };

    fetchData();
  }, [refreshEscalation]);

  const startEdit = (key, item) => {
    setEditingEscalationRow(key);
    setEditSelections((p) => ({
      ...p,
      [key]: { categoryId: item.categoryId, subCategoryId: item.subCategoryId },
    }));
    setEditLevel1Hour((p) => ({ ...p, [key]: item.escalationHour1 || "" }));
    setEditLevel2Hour((p) => ({ ...p, [key]: item.escalationHour2 || "" }));
    setEditLevel3Hour((p) => ({ ...p, [key]: item.escalationHour3 || "" }));
  };

  const cancelEdit = () => {
    setEditingEscalationRow(null);
    setEditSelections({});
    setEditLevel1Hour({});
    setEditLevel2Hour({});
    setEditLevel3Hour({});
  };

  const handleSaveEscalation = async (item, isNew = false) => {
    const uid = getLoggedUserId();
    if (!uid) return toast.error("Login required");

    let catId, subId, id, h1, h2, h3;
    let key = "";

    if (isNew) {
      catId = newEscalationData.categoryId;
      subId = newEscalationData.subCategoryId;
      h1 = newEscalationData.escalationHour1;
      h2 = newEscalationData.escalationHour2;
      h3 = newEscalationData.escalationHour3;
      key = `${catId}_${subId}`;
    } else {
      id = item.escalationId;
      key = `${item.categoryId}_${item.subCategoryId}`;
      catId = editSelections[key]?.categoryId || item.categoryId;
      subId = editSelections[key]?.subCategoryId || item.subCategoryId;
      h1 = editLevel1Hour[key] || "";
      h2 = editLevel2Hour[key] || "";
      h3 = editLevel3Hour[key] || "";
    }

    if (!catId || !subId) return toast.warning("Please select category & sub-category");

    try {
      setEscalationLoading(true);
      const endPoint = { urlVariable: null, buildingId: getBuildingId() };

      const payload = id
        ? {
            escalationId: id,
            modifiedUserId: uid.toString(),
            categoryId: +catId,
            subCategoryId: +subId,
            escalationHour1: +h1 || 0,
            escalationHour2: +h2 || 0,
            escalationHour3: +h3 || 0,
          }
        : {
            createdUserId: uid.toString(),
            categoryId: +catId,
            subCategoryId: +subId,
            escalationHour1: +h1 || 0,
            escalationHour2: +h2 || 0,
            escalationHour3: +h3 || 0,
          };

      const api = id ? "UpdateComplaintEsclation" : "AddComplaintEsclation";
      const res = await commonAPI(api, payload, endPoint);

      if (res?.success) {
        toast.success(isNew ? "Added" : "Updated");
        if (isNew) {
          setNewEscalationData({ categoryId: "", subCategoryId: "", escalationHour1: "", escalationHour2: "", escalationHour3: "" });
          setShowAddRow(false);
          setShowFAB(true);
        }
        cancelEdit();
        setRefreshEscalation((p) => p + 1);
      } else {
        toast.error(res?.message?.[0] || "Save failed");
      }
    } catch (err) {
      toast.error("Save error");
    } finally {
      setEscalationLoading(false);
    }
  };

  const handleDeleteClick = (c, s, id) => {
    setDeleteTarget({ categoryName: c, subCategoryName: s, escalationId: id });
    setDeleteShow(true);
  };

  const handleConfirmDelete = async () => {
    if (!deleteTarget?.escalationId) return;

    try {
      setEscalationLoading(true);
      const payload = {
        escalationId: deleteTarget.escalationId,
        modifiedUserId: getLoggedUserId().toString(),
      };
      const endPoint = { urlVariable: null, buildingId: getBuildingId() };
      const res = await commonAPI("DeleteComplaintEsclation", payload, endPoint);

      if (res?.success) {
        toast.success("Deleted");
        setDeleteShow(false);
        setDeleteTarget(null);
        setRefreshEscalation((p) => p + 1);
      } else {
        toast.error(res?.message?.[0]);
      }
    } catch (err) {
      toast.error("Delete error");
    } finally {
      setEscalationLoading(false);
    }
  };

  return (
    <div className="container-fluid position-relative">
      <div className="row">
        <div className="col-12">
          <div className="mt-3">

            {escalationLoading && (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            )}

            {!escalationLoading && (
              <>
                <div
                  style={{
                    overflow: "auto",
                    maxHeight: "400px",
                    border: "1px solid #dee2e6",
                    borderRadius: "8px",
                    position: "relative",
                    backgroundColor: "#fff",
                  }}
                >
                  <Table striped bordered hover responsive className="compact-table mb-0">
                    <thead style={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 10 }}>
                      <tr>
                        <th style={{ width: "18%" }}>Category</th>
                        <th style={{ width: "18%" }}>Sub Category</th>
                        <th style={{ width: "12%" }}>L1 Hour</th>
                        <th style={{ width: "12%" }}>L2 Hour</th>
                        <th style={{ width: "12%" }}>L3 Hour</th>
                        <th style={{ width: "10%" }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {escalationData.map((data) => {
                        const key = `${data.categoryId}_${data.subCategoryId}`;
                        const isEditing = editingEscalationRow === key;
                        const currentCatId = editSelections[key]?.categoryId ?? data.categoryId;
                        const currentSubId = editSelections[key]?.subCategoryId ?? data.subCategoryId;
                        const subCats = getSubCategoriesForCategory(currentCatId);

                        return (
                          <tr key={key}>
                            <td>
                              {isEditing ? (
                                <select
                                  className="form-select form-select-sm"
                                  value={editSelections[key]?.categoryId || ""}
                                  onChange={(e) =>
                                    setEditSelections((p) => ({
                                      ...p,
                                      [key]: { ...p[key], categoryId: e.target.value, subCategoryId: "" },
                                    }))
                                  }
                                >
                                  <option value="">Select</option>
                                  {categoryList.map((c) => (
                                    <option key={c.categoryId} value={c.categoryId}>
                                      {c.categoryName}
                                    </option>
                                  ))}
                                </select>
                              ) : (
                                <div style={{ padding: "8px 0", fontWeight: "600" }}>
                                  {data.categoryName}
                                </div>
                              )}
                            </td>

                            <td>
                              {isEditing ? (
                                <select
                                  className="form-select form-select-sm"
                                  value={editSelections[key]?.subCategoryId || ""}
                                  onChange={(e) =>
                                    setEditSelections((p) => ({
                                      ...p,
                                      [key]: { ...p[key], subCategoryId: e.target.value },
                                    }))
                                  }
                                >
                                  <option value="">Select</option>
                                  {subCats.map((s) => (
                                    <option key={s.subCategoryId} value={s.subCategoryId}>
                                      {s.subCategoryName}
                                    </option>
                                  ))}
                                </select>
                              ) : (
                                <div style={{ padding: "8px 0" }}>{data.subCategoryName}</div>
                              )}
                            </td>

                            <td>
                              {isEditing ? (
                                <input
                                  type="number"
                                  className="form-control form-control-sm"
                                  value={editLevel1Hour[key] || ""}
                                  onChange={(e) => setEditLevel1Hour((p) => ({ ...p, [key]: e.target.value }))}
                                  min="0"
                                />
                              ) : (
                                <div style={{ padding: "8px 0" }}>{data.escalationHour1 || "-"}</div>
                              )}
                            </td>

                            <td>
                              {isEditing ? (
                                <input
                                  type="number"
                                  className="form-control form-control-sm"
                                  value={editLevel2Hour[key] || ""}
                                  onChange={(e) => setEditLevel2Hour((p) => ({ ...p, [key]: e.target.value }))}
                                  min="0"
                                />
                              ) : (
                                <div style={{ padding: "8px 0" }}>{data.escalationHour2 || "-"}</div>
                              )}
                            </td>

                            <td>
                              {isEditing ? (
                                <input
                                  type="number"
                                  className="form-control form-control-sm"
                                  value={editLevel3Hour[key] || ""}
                                  onChange={(e) => setEditLevel3Hour((p) => ({ ...p, [key]: e.target.value }))}
                                  min="0"
                                />
                              ) : (
                                <div style={{ padding: "8px 0" }}>{data.escalationHour3 || "-"}</div>
                              )}
                            </td>

                            <td>
                              <div style={{ display: "flex", gap: "5px", justifyContent: "center" }}>
                                {isEditing ? (
                                  <>
                                    <button
                                      className="btn btn-sm btn-success"
                                      onClick={() => handleSaveEscalation(data, false)}
                                      disabled={escalationLoading}
                                    >
                                      <FontAwesomeIcon icon={faCheck} />
                                    </button>
                                    <button
                                      className="btn btn-sm btn-secondary"
                                      onClick={cancelEdit}
                                      disabled={escalationLoading}
                                    >
                                      <FontAwesomeIcon icon={faTimes} />
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    <button
                                      className="btn btn-sm btn-primary"
                                      onClick={() => startEdit(key, data)}
                                      disabled={escalationLoading}
                                    >
                                      <FontAwesomeIcon icon={faPenToSquare} />
                                    </button>
                                    <button
                                      className="btn btn-sm btn-danger"
                                      onClick={() => handleDeleteClick(data.categoryName, data.subCategoryName, data.escalationId)}
                                      disabled={escalationLoading}
                                    >
                                      <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                  </>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}

                      {showAddRow && (
                        <tr style={{ backgroundColor: "#f0f8ff" }}>
                          <td>
                            <select
                              className="form-select form-select-sm"
                              value={newEscalationData.categoryId}
                              onChange={(e) =>
                                setNewEscalationData((p) => ({
                                  ...p,
                                  categoryId: e.target.value,
                                  subCategoryId: "",
                                }))
                              }
                            >
                              <option value="">Select</option>
                              {categoryList.map((c) => (
                                <option key={c.categoryId} value={c.categoryId}>
                                  {c.categoryName}
                                </option>
                              ))}
                            </select>
                          </td>
                          <td>
                            <select
                              className="form-select form-select-sm"
                              value={newEscalationData.subCategoryId}
                              onChange={(e) =>
                                setNewEscalationData((p) => ({ ...p, subCategoryId: e.target.value }))
                              }
                            >
                              <option value="">Select</option>
                              {getSubCategoriesForCategory(newEscalationData.categoryId).map((s) => (
                                <option key={s.subCategoryId} value={s.subCategoryId}>
                                  {s.subCategoryName}
                                </option>
                              ))}
                            </select>
                          </td>
                          <td><input type="number" className="form-control form-control-sm" value={newEscalationData.escalationHour1} onChange={(e) => setNewEscalationData(p => ({ ...p, escalationHour1: e.target.value }))} min="0" /></td>
                          <td><input type="number" className="form-control form-control-sm" value={newEscalationData.escalationHour2} onChange={(e) => setNewEscalationData(p => ({ ...p, escalationHour2: e.target.value }))} min="0" /></td>
                          <td><input type="number" className="form-control form-control-sm" value={newEscalationData.escalationHour3} onChange={(e) => setNewEscalationData(p => ({ ...p, escalationHour3: e.target.value }))} min="0" /></td>
                          <td>
                            <div style={{ display: "flex", gap: "5px" }}>
                              <button className="btn btn-sm btn-success" onClick={() => handleSaveEscalation({}, true)} disabled={escalationLoading}>
                                <FontAwesomeIcon icon={faCheck} />
                              </button>
                              <button className="btn btn-sm btn-secondary" onClick={cancelAddRow}>
                                <FontAwesomeIcon icon={faTimes} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>

                  {/* Plus Button - inside container, original position */}
                  {showFAB && !showAddRow && (
                    <div style={{ position: "absolute", bottom: "16px", right: "16px", zIndex: 20 }}>
                      <button
                        className="btn rounded-circle shadow-lg d-flex align-items-center justify-content-center"
                        style={{
                          backgroundColor: BLUE_COLOR,
                          borderColor: BLUE_COLOR,
                          color: "#fff",
                          width: "56px",
                          height: "56px",
                          fontSize: "1.5rem",
                        }}
                        onClick={handleFABClick}
                        disabled={escalationLoading || pendingRecipientSave}
                        title="Save Recipients & Add New Escalation"
                      >
                        {pendingRecipientSave ? (
                          <div className="spinner-border spinner-border-sm text-light" role="status" />
                        ) : (
                          <FontAwesomeIcon icon={faPlus} />
                        )}
                      </button>
                    </div>
                  )}
                </div>

                {/* Recipient Cards */}
                <div className="row mt-4">
                  {[1, 2, 3].map((level) => (
                    <div key={level} className="col-md-4 mb-3">
                      <div className="card h-100">
                        <div className="card-header text-white" style={{ backgroundColor: BLUE_COLOR, borderColor: BLUE_COLOR }}>
                          <h6 className="mb-0">Level {level} Recipients</h6>
                        </div>
                        <div className="card-body d-flex flex-column">
                          <div className="mb-3 flex-grow-1" style={{ minHeight: "80px", maxHeight: "150px", overflowY: "auto" }}>
                            {(() => {
                              const list = level === 1 ? recipient1List : level === 2 ? recipient2List : recipient3List;
                              return list.length === 0 ? (
                                <p className="text-muted small">No recipients</p>
                              ) : (
                                <div className="d-flex flex-wrap gap-2">
                                  {list.map((email, i) => (
                                    <div
                                      key={i}
                                      className="badge bg-light text-dark d-flex align-items-center"
                                      style={{ padding: "6px 8px", fontSize: "12px" }}
                                    >
                                      {email}
                                      <FontAwesomeIcon
                                        icon={faTimes}
                                        className="ms-2"
                                        style={{ cursor: "pointer", color: "#dc3545" }}
                                        onClick={() => removeRecipient(level, i)}
                                      />
                                    </div>
                                  ))}
                                </div>
                              );
                            })()}
                          </div>

                          <div className="input-group input-group-sm mt-auto">
                            <input
                              type="email"
                              className="form-control"
                              placeholder="email@example.com"
                              value={level === 1 ? recipient1Input : level === 2 ? recipient2Input : recipient3Input}
                              onChange={(e) =>
                                level === 1
                                  ? setRecipient1Input(e.target.value)
                                  : level === 2
                                    ? setRecipient2Input(e.target.value)
                                    : setRecipient3Input(e.target.value)
                              }
                              onKeyPress={(e) => e.key === "Enter" && addRecipient(level)}
                            />
                            <button
                              className="btn"
                              style={{ backgroundColor: BLUE_COLOR, borderColor: BLUE_COLOR, color: "#fff" }}
                              onClick={() => addRecipient(level)}
                            >
                              <FontAwesomeIcon icon={faPlus} />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}

            {escalationData.length === 0 && !showAddRow && !escalationLoading && (
              <div className="text-center py-5 text-muted">No escalations available</div>
            )}
          </div>
        </div>
      </div>

      <Modal centered show={DeleteShow} onHide={() => setDeleteShow(false)}>
        <Modal.Body className="p-4 text-center">
          <h4>Delete Escalation</h4>
          <p>
            Are you sure you want to delete escalation for "
            <strong>{deleteTarget?.categoryName} - {deleteTarget?.subCategoryName}</strong>"?
          </p>
          <div className="d-flex justify-content-center gap-3 mt-3">
            <Button variant="danger" onClick={handleConfirmDelete}>Delete</Button>
            <Button variant="light" onClick={() => setDeleteShow(false)}>Cancel</Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Escalation;